import { createColumnHelper } from "@tanstack/react-table";
import { ModalExceles } from "components/Modals/ModalExceles";
import { format } from "date-fns";
import useUser from "hooks/useUser";
import ModalSerie from "pages/Modal/ModalSeries";
import ModalActualizarSerie from "pages/Modal/ModalActualizarSerie";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { obtenerLogsSerials } from "services/series";
import DynamicTable from "utilities/DynamicTable";

const vista = "updating-serials";
const columnHelper = createColumnHelper();


export default function Series() {
    // const { getAccessories } = useAccessories();
    const { tokenFull, IdUser } = useUser();
    const [series, setSeries] = useState([]);
    const [modalDetallesOpen, setModalDetallesOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const handleModal = (flag) => setOpenModal(flag);
    const [openActualizar, setOpenActualizar] = useState(false);
    const [Id, setId] = useState("");

    const fetchLog = async ()=>{
      const response = await obtenerLogsSerials(tokenFull);
      response.forEach((item)=>{
        const date = new Date(item.fecha_actualizacion);
        const formattedDate = format(date, 'dd/MM/yyyy HH:mm:ss');
        item.fecha_actualizacion = formattedDate;
      })
      setSeries(response);
    }

    useEffect(()=>{
      fetchLog();
    },[])

    const handleViewModal = (id) => {
        setId(id);
        setModalDetallesOpen(true);
    };

    // const handleModal = () =>{
    //   setOpenModal(true);
    // }

    const columns = [
      columnHelper.accessor('id',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            ID
          </span>
        ),
        enableGlobalFilter: false,
      }),
      columnHelper.accessor('nombre',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            Usuario
          </span>
        )
      }),
      columnHelper.accessor('fecha_actualizacion',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            Fecha de actualización
          </span>
        ),
      }),
      columnHelper.accessor('cantidad_total_anterior',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            Cantidad de total anterior
          </span>
        ),
        enableGlobalFilter: false,
      }),
      columnHelper.accessor('cantidad_nuevos_registros',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            Cantidad de nuevos registros
          </span>
        ),
        enableGlobalFilter: false,
      }),
      columnHelper.accessor('cantidad_total_nueva',{
        cell: (info)=> info.getValue(),
        header: ()=>(
          <span className="flex align-items-center">
            Cantidad nueva total
          </span>
        ),
        enableGlobalFilter: false,
      }),
      columnHelper.accessor('cantidad_archivos',{
        cell: (info)=> {
          const cantidad = info.getValue();
          return cantidad !== 0 ? (
            <button
            className="btn btn-secondary btn-sm"
            onClick={() => handleViewModal(info.row.original.id)}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
            }}
            >
              Ver Detalles
            </button>
          ) : <p>Sin cambios</p>
        },
        header: ()=>(
          <span className="flex align-items-center">
            Archivos
          </span>
        ),
        enableGlobalFilter: false,
      })
    ];
  
    return (
        <div className="container">
            <div className="text-center">
                <h1 style={{ fontFamily: "STIHL_title",fontWeight: "bold",marginTop: "27px",fontSize: "2rem", marginBottom:"15px" }}>
                    Actualizaciones de Números Serie
                </h1>
                <div className="d-flex justify-content-end gap-2">
                  <Button
                    variant="info"
                    onClick={()=> handleModal(true)}
                  >Registrar</Button>
                  <button
                    className="btn btn-secondary btn-sm"
                    style={{
                      backgroundColor: "#6c757d",
                      borderColor: "#6c757d",
                      color: "#fff",
                    }}
                    onClick={()=> setOpenActualizar(true)}
                  >Actualizar</button>
                </div>
                <div className="mx-auto" style={{ maxWidth: "80%" }}>
                    <DynamicTable columns={columns} data={series} />
                    {/* <DynamicTable columns={columns} data={series} view={vista} /> */}
                </div>
            </div>
            <ModalSerie
                modal={modalDetallesOpen}
                toggle={() => setModalDetallesOpen(!modalDetallesOpen)}
                Id={Id}
                token={tokenFull}
                // facturaUrl={facturaUrl}
            />
            <ModalExceles
              modal={openModal}
              toggle={()=> setOpenModal(!openModal)}
              fetchData={fetchLog}
            />
            <ModalActualizarSerie
              modal={openActualizar}
              toggle={()=> setOpenActualizar(!openActualizar)}
              token={tokenFull}
              IdUser={IdUser}
              fetchData={fetchLog}
            />
        </div>
    );
  }
  